// extracted by mini-css-extract-plugin
export default {"wrapper":"VideoPlayer_wrapper__3WiVZ","iframeWrapper":"VideoPlayer_iframeWrapper__aqyKr"};